<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full'">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-2">
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
							formControlName="name" placeholder="">
						<label for="name">Category Name*</label>
					</div>
					<p *ngIf="showError('name')" class="text-danger">
						<span *ngIf="f.name.errors?.required">
							Required
						</span>
						<span *ngIf="f.name.errors?.incorrect">
							{{customError.name}}
						</span>
					</p>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<ng-select id="scales_id" [items]="scaleList" bindLabel="scale_name" bindValue="id"
						[clearable]="true" placeholder="Scale*" formControlName="scales_id" appearance="outline"
						[ngClass]="{'is-invalid':showError('scales_id')}">
					</ng-select>
					<p *ngIf="showError('scales_id')" class="text-danger">
						<span *ngIf="f.scales_id.errors?.required">
							Required
						</span>
						<span *ngIf="f.scales_id.errors?.incorrect">
							{{customError.scales_id}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th style="width: 5%;">#</th>
								<th style="width: 60%;">Question</th>
								<th style="width: 20%;">Condition</th>
								<th style="width: 10%;">Value</th>
								<th style="width: 5%;">
									<button type="button" (click)="addRow()" class="btn btn-xs btn-outline-primary"
										matTooltip="Add">
										<fa-icon [icon]="['fas', 'plus']"></fa-icon>
									</button>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr formArrayName="questions" *ngFor="let creds of get_rows.controls; let i = index">
								<ng-container [formGroupName]="i">
									<td>{{i+1}}</td>
									<td>
										<ng-select [items]="questionList" bindLabel="question_name" bindValue="id"
											[clearable]="true" placeholder="Question" id="que{{i}}"
											formControlName="que" appearance="outline">
										</ng-select>
										<p *ngIf="showError2(i,'que')" class="text-danger">
											<span *ngIf="creds.get('que')?.errors?.required">
												Required
											</span>
										</p>
									</td>
									<td>
										<mat-radio-group formControlName="condition">
											<mat-radio-button [value]="'1'" [color]="'primary'">
												Yes
											</mat-radio-button>
											<mat-radio-button [value]="'0'" [color]="'primary'">
												Default
											</mat-radio-button>
										</mat-radio-group>
										<p *ngIf="showError2(i,'condition')" class="text-danger">
											<span *ngIf="creds.get('condition')?.errors?.required">
												Required
											</span>
										</p>
									</td>
									<td>
										<div class="form-floating">
											<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'value')}"
												id="value{{i}}" formControlName="value" placeholder="">
											<label for="value">Value*</label>
										</div>
										<p *ngIf="showError2(i,'value')" class="text-danger">
											<span *ngIf="creds.get('value')?.errors?.required">
												Required
											</span>
										</p>
									</td>
									<td>
										<button type="button" (click)="deleteRow(i)" class="btn btn-xs btn-danger"
											matTooltip="Remove">
											<fa-icon [icon]="['fas', 'times']"></fa-icon>
										</button>
									</td>
								</ng-container>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col text-center">
					<button type="button" (click)="addRow()" class="btn btn-sm btn-outline-primary me-1">
						<fa-icon [icon]="['fas', 'plus']"></fa-icon>
						Add
					</button>
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success me-1">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark me-1" [routerLink]="['/app/category-list']">
						Cancel
					</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>